import { ReelSpin } from "./ReelSpin";
// import { Ui } from "../ui/Ui"
import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { /*BlurFilter, ColorMatrixFilter,*/ BitmapText, Container } from 'pixi.js';
import { /*Tween,*/ Group, Tween } from "tweedle.js";

// import { ColorOverlayFilter } from "pixi-filters";
import { /*SpinDataObject,*/ spinData, WinObject } from '../server/getServerResposesFun';
// import { TextAnimate } from "./TextAnimate"
// import { isOversizeSymbol } from "../config/getSymbol";

import {
    REEL_DIVIDER,
    REEL_NUMBERS,
    REEL_WIDTH,
    SYMBOL_HEIGHT,
    SYMBOLS_PER_REEL,
} from "../config/reelConfig";

import { sound } from "@pixi/sound";
import { jurisdictionGlobal } from "../config/GlobalVariableConfig";

// const style = new TextStyle({
//     fill: "#ffffff",
//     fontFamily: "Arial Black",
//     fontSize: 50
// });


// const lineWinTextStyle = new TextStyle({
//     fontFamily: 'Helvetica',
//     fontSize: 100,
//     // fill: "#fed716",
//     fill: "#ffffff",
//     fontWeight: "bold",
//     stroke: '#000000',
//     // stroke: '#4a1850',
//     dropShadow: true,

// });

const lineWinText = new BitmapText({
    text: '',
    style: {
        fontFamily: "sugar_win_amount",
        trim: true,
        fontSize: 120,
        letterSpacing: 15,
    }

});


const lineWinTextContainer = new Container();

const textTweenGroup = new Group();

export class ReelWin extends ReelSpin {

    // private lineWinText = new Text({});
    private winSymbolArray: number[][] = [];

    private winLines: WinObject[] | null = null; // object for winning Lines 
    // Uncomment once the backend is fixed
    // private winScatters: WinObject[] | null = null; // object for winning Scatters 



    // private totalWin: number = 0;

    private winLinesSPine: Spine | null = null;

    constructor() {
        super();

        // this.lineWinText.text = "";
        // this.lineWinText.style = style;

        // this.lineWinText.x = 500;
        // this.lineWinText.y = -100;

        // this.reelOverlayContainer.addChild(this.lineWinText);

        textTweenGroup.removeAll();
    }


    public updateReelWin() {
        this.updateReelSpin();

        textTweenGroup.update();

    }

    private setWinObjectsVal(currentRespinIndex: number) {
        // this.setWinObjectsVal();
        this.winLines = spinData.respins[currentRespinIndex].winLines;

        // Uncomment once the backend is fixed
        // this.winScatters = spinData.respins[currentRespinIndex].winScatters;



        // console.log(spinData.respins[currentRespinIndex].winAmount);
        // this.totalWin = spinData.respins[currentRespinIndex].winAmount;
    }

    // private setWinLineSpineObj(){

    //     this.winLinesSPine = Spine.from({
    //         skeleton: "winLineSkel",
    //         atlas: "winLineAtlas",
    //     });

    //     this.winLinesSPine.state.clearTracks();
    // }

    // private async waitFunction(time: number): Promise<void> {
    //     return new Promise((resolve) => {

    //         setTimeout(() => {
    //             resolve();
    //         }, time);

    //     })
    // }

    private initWinSymbolArray() {
        // Initialize winSymbolArray with zeros
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.winSymbolArray[i] = [];
            for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                this.winSymbolArray[i][j] = 0; // Initialize to 0
            }
        }
    }

    // export interface WinObject { // the object -how we want to use in our program 
    //     lineId: number | null;
    //     symbolId: number;
    //     winAmount: number;
    //     winSymbolPosistions: number[][]| null;
    // }


    private setWinSymbolArray(winObjects: WinObject[]) {
        // Iterate through winLines
        winObjects?.forEach((winObject) => {
            if (winObject.winSymbolPosistions) {
                // Adjust the type of reelNum and posNum to number

                winObject.winSymbolPosistions.forEach((winSymbolPosistion) => {

                    const reelNum: number = winSymbolPosistion[0];
                    const posNum: number = winSymbolPosistion[1];

                    // Mark the position as 1
                    this.winSymbolArray[reelNum][posNum] = 1;
                })
            }
        });
    }

    private getWinLineNmubers(): number[] {
        const winLineNmubers: number[] = [];//(number | null)[] | null  = null;  // define in a better way numbers[] | null

        this.winLines?.forEach((winLine) => {

            if (winLine.lineId) {
                winLineNmubers.push(winLine.lineId);
            }

        })

        // this.winlineNumbers = spinData.winLines?.map(line => line.lineId) ?? null; //[1, 2, 3]; // ?? null to change undefined value to null

        // when use in toggeling -> empty this array and push single line id, in the animation function use winlineNumbers.length

        return winLineNmubers;
    }



    // this is main function which is doing the animation -

    //this will just makeNonwinSymbolDark
    public async animateWinningSymbols(currentRespinIndex: number): Promise<void> {

        // console.log("inside animateWinningSymbols");

        this.setupLineWintext();

        this.setWinObjectsVal(currentRespinIndex);
        // this.setWinLineSpineObj();

        // this pause is mandatory to settle all reels, and observe the landing animations before starting next spin, specially in auto play
        if (spinData.respins[currentRespinIndex].winAmount == 0) {
            // console.log("no win");

            // await this.waitFunction(500);

            this.running = false;

            return Promise.resolve();
        }



        // console.log(this.spinData.winScatters);




        // if (winLines?.length == 0 && winScatters?.length == 0) {

        //     this.running = false;
        //     console.log(`running ${this.running}`);
        // }

        this.initWinSymbolArray();


        this.winLines?.forEach((winLine) => {

            const winlines: WinObject[] = [];
            winlines.push(winLine)

            this.setWinSymbolArray(winlines);
        })


        // Uncomment once the backend is fixed
        // this.winScatters?.forEach((winScatter) => {

        //     const winScatters : WinObject[] = [];
        //     winScatters.push(winScatter)

        //     this.setWinSymbolArray(winScatters);
        // })

        const winlineNumbers: number[] = this.getWinLineNmubers();

        // setWinSymbolArray

        console.log(winlineNumbers);


        // await this.animateWinningLines(winlineNumbers);

        // await this.makeNonwinSymbolDark();

        // await this.waitFunction(500),

        console.log("all line animations are completed");

        // return this.totalWin;

        // await this.lineLoggle(currentRespinIndex);



    }


    // private winningSymbolOnTop() {
    //     // this.reset
    //     // first take winning symbol on top
    //     this.winSymbolArray.forEach((reels, reelNum) => {
    //         reels.forEach((symbol, posNum) => {
    //             if (symbol == 1) // win animation
    //             {
    //                 // console.log(`reelNum ${reelNum}`);
    //                 // console.log(`posNum ${posNum}`);

    //                 // take them on top

    //                 let winSymbol = this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`) as Spine;
    //                 this.reelOverlayContainer.addChild(winSymbol);

    //             }
    //         })
    //     })

    //     // then take oversized symbol on top of that
    //     this.winSymbolArray.forEach((reels, reelNum) => {
    //         reels.forEach((symbol, posNum) => {
    //             if (symbol == 1) // win animation
    //             {
    //                 const symbolId: number = this.allReelArray[reelNum].symbols[posNum].y;

    //                 if (isOversizeSymbol(symbolId)) // symbolId of oversized symbols 
    //                 {
    //                     const winSymbol: Spine | null = this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`) as Spine;
    //                     this.reelOverlayContainer.addChild(winSymbol)
    //                 }
    //             }
    //         })
    //     })
    // }


    // Function to calculate position based on lineNumber

    private getTextAnimatePos(): number {
        // // Function to find the first winning position on reel 3
        // const firstWinPosOnReel3 = (): number | undefined => {
        //     for (let i = 0; i < this.winSymbolArray[2].length; i++) {
        //         if (this.winSymbolArray[2][i] === 1) {
        //             return (i); // Return the position
        //         }
        //     }
        //     return undefined; // If no win position is found
        // }

        // const firstWinPos = firstWinPosOnReel3(); // Get the first win position
        // if (firstWinPos !== undefined) {
        //     const position = (firstWinPos + 0.75) * SYMBOL_HEIGHT;

        //     return position;
        // }

        // // Handle the case where no win position is found (default value)
        // return 0;

        // console.log("getTextAnimatePos", this.winSymbolArray);


        const mappedArray = this.winSymbolArray[0].map((_, colIndex) =>
            this.winSymbolArray.some(row => row[colIndex] === 1) ? 1 : 0
        );

        // Step 2: Get indexes with 1s
        const indexesWithOnes = mappedArray
            .map((value, index) => (value === 1 ? index : -1))
            .filter(index => index !== -1);

        // Step 3: Calculate Median
        let median: number;
        const len = indexesWithOnes.length;

        if (len === 0) {
            median = -1; // Handle case with no 1s
        } else if (len % 2 === 0) {
            median = (indexesWithOnes[len / 2 - 1] + indexesWithOnes[len / 2]) / 2;
        } else {
            median = indexesWithOnes[Math.floor(len / 2)];
        }

        // console.log("Mapped Array:", mappedArray);        // [1, 1, 1, 1, 1, 0]
        // console.log("Indexes with 1s:", indexesWithOnes); // [0, 1, 2, 3, 4]
        // console.log("Median index:", median);             // 2

        return (median + 0.5) * SYMBOL_HEIGHT;


    }




    private async runAnimation(): Promise<void> // play animation of symbols having value 1 in the array winSymbolArray
    {

        // console.log("inside runAnimation", this.winSymbolArray);

        //wait is mandatory  as runAnimation is calling before updating winArrayToAnimate
        // await new Promise(resolve => setTimeout(resolve, 100));

        return new Promise((resolve) => {
            // then animate symbols
            let eventListnerAdded = false;

            this.winSymbolArray.forEach((reels, reelNum) => {
                reels.forEach((symbol, posNum) => {
                    if (symbol == 1) { // winning symbol which will aninate 


                        let winSymbol = this.allReelArray[reelNum].symbols[posNum].symbol //this.reelOverlayContainer.getChildByLabel(`${reelNum * 3 + posNum}`) as Spine;

                        // let symbolId = this.allReelArray[reelNum].symbols[posNum].id;
                        // let wildMultVal = this.allReelArray[reelNum].symbols[posNum].multVal;

                        // if (symbolId != 0) {
                        //     winSymbol.state.setAnimation(0, "win", false);
                        // }
                        // else {
                        //     winSymbol.state.setAnimation(0, wildMultVal === 0 ? "win" : "wild_multiplier_win", false);
                        // }

                        winSymbol.state.setAnimation(0, "win", false);

                        if (!eventListnerAdded && winSymbol) {
                            eventListnerAdded = true;

                            // console.log("Adding event listener"); 

                            winSymbol.state.addListener({
                                // start: () => {
                                //     console.log("onAnimationStart");    
                                // },

                                complete: () => {
                                    // console.log("onAnimationEnd");

                                    // textanimate.removeTextAnimate();

                                    // winSymbolForListner.state.removeListener(); // Corrected
                                    winSymbol.state.clearListeners(); // Corrected
                                    // clearTint();
                                    resolve(); // Ensure resolve is defined in the scope
                                }
                            });
                        }

                    }
                });
            });

        });
    }


    private async animateWinningLines(winlineNumbers: number[], winAmt?: number, currentMult?: number): Promise<void> {
        // If winAmt is 0, resolve the promise immediately
        if (winAmt === 0) {
            return Promise.resolve();
        }

        // Clear any existing tracks
        this.winLinesSPine?.state.clearTracks();

        // Set paying line (numbers) - animations for each winning line
        for (let currentLineIndex = 0; currentLineIndex < winlineNumbers.length; currentLineIndex++) {
            const winLineId = winlineNumbers[currentLineIndex];
            const winAnimationName = `payline_${winLineId}`;
            this.winLinesSPine?.state.setAnimation(currentLineIndex, winAnimationName, false); // Play the animation once
        }

        // Handle winning symbols
        // this.winningSymbolOnTop();

        // Add the win lines spine to the overlay container if there are winning lines
        if (winlineNumbers.length > 0 && this.winLinesSPine) {
            this.reelOverlayContainer.addChild(this.winLinesSPine);
        }

        // Initialize text animation if winAmt is non-zero
        // let textanimate: TextAnimate | null = null;
        if (winAmt) {
            // const texttickupDuration = 0;
            // const textanimationDuration = 500;
            // const decimalPlace = 2;


            const textAnimationY = this.getTextAnimatePos();
            lineWinTextContainer.y = textAnimationY;




            // Run both updateNumberText and runAnimation concurrently
            await Promise.all([
                this.runAnimation(),
                this.updateNumberText(winAmt / currentMult, currentMult),
            ]);

        }
        else {
            await this.runAnimation();
        }






    }

    private setupLineWintext() {

        lineWinText.anchor = 0.5;
        lineWinTextContainer.addChild(lineWinText);

        this.reelOverlayContainer.addChild(lineWinTextContainer);

        // new TextAnimate(textTweenGroup, winAmt, decimalPlace, texttickupDuration, textanimationDuration);
        lineWinTextContainer.x = (REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER) / 2;


    }

    private async updateNumberText(winAmt: number, currentMult?: number): Promise<void> {
        // console.log(`currentMult ${currentMult}`);

        if (currentMult && currentMult > 1) {
            lineWinText.text = `${winAmt.toFixed(2)} x ${currentMult}`;
        }
        else {
            lineWinText.text = `${winAmt.toFixed(2)}`;
        }

        lineWinText.scale = 1;
        const textScale = Math.min(850 / lineWinText.width, 1);

        const tweenToScale = new Tween(lineWinText, textTweenGroup)
            .to({ scale: { x: textScale, y: textScale }, alpha: 1 }, 200)
            .onStart(() => {
                // sound.play('symbol_win', { volume: 0.1 })

                if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                    // sound.play('symbol_win', { volume: 0 })
                }
                else {
                    // sound.play('symbol_win', { volume: .3 })
                    sound.play('Free_Game_Banner_Disppear', { volume: .5 })
                }

            })
            .easing(backout(4))
            .onComplete(() => {
                textTweenGroup.remove(tweenToScale)
            })
            .start();

        await new Promise(resolve => setTimeout(resolve, 500));

        // let isWinHigherBet = false;
        // let totalWin = currentMult ? winAmt * currentMult : winAmt
        // if (totalWin > betValueGlobal) {
        //     isWinHigherBet = true;
        // }
        // console.log("isWinHigherBet jurisdictionGlobal totalWin betValueGlobal", isWinHigherBet, jurisdictionGlobal, totalWin, betValueGlobal);




        if (currentMult && currentMult > 1) {

            let currentVal: number = winAmt;
            let targetVal: number = winAmt * currentMult;
            const tweenToTickup = new Tween({ x: currentVal }, textTweenGroup)
                .to({ x: targetVal }, 100)
                .onStart(() => {
                    // sound.play('symbol_win_multiply', { volume: 0.2 });

                    if (["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 && !spinData.isWinHigherBet) {
                        // sound.play('symbol_win_multiply', { volume: 0 })
                    }
                    else {
                        sound.play('symbol_win_multiply', { volume: .1 })
                    }
                })
                .onUpdate((object) => {
                    lineWinText.text = `${(currentVal).toFixed(2)}`;
                    currentVal = object.x; // Update currentVal with the tweened value
                    // console.log(`in tween currentVal: ${currentVal}`);
                })
                .onComplete(() => {
                    lineWinText.text = `${(targetVal).toFixed(2)}`;
                    textTweenGroup.remove(tweenToTickup)
                })
                .start();

            await new Promise(resolve => setTimeout(resolve, 500));

        }
        else {
            await new Promise(resolve => setTimeout(resolve, 500));

        }

        lineWinText.text = ``;
        lineWinText.scale = 1;

        function backout(amount: number): (t: number) => number {
            return (t: number) => --t * t * ((amount + 1) * t + amount) + 1;
        }


    }






    public async processWinFeatureSymbol(currentRespinIndex: number): Promise<void> {


        // let currentRespinIndex: number = 0;//spinData.respins.length-1;

        const winScatter = spinData.respins[currentRespinIndex - 1].winScatters[0]

        // console.log("inside processWinFeatureSymbol", winScatter);


        // sound.play('scatter_win', { volume: 0.7 })

        this.initWinSymbolArray();


        if (winScatter) {
            const winScatters: WinObject[] = [];
            winScatters.push(winScatter);

            this.setWinSymbolArray(winScatters);
            sound.play('Scatter_Trigger');
            await this.animateWinningLines([]);
        }

    }


    /*********************** Line Toggle ******************** */
    private async processWinObjectsToggel(winObjects: WinObject[] | null, winSymbolIds: number[], currentIndex: number, isLine: boolean): Promise<void> {
        if (winObjects?.length === 0) {
            // console.log(`No win ${isLine ? 'lines' : 'scatters'} to process.`);
            return;
        }

        if (winObjects === null) {
            return;
        }

        // Reset the index if it exceeds the length of winObjects
        if (currentIndex >= winObjects.length) {
            return;
        }

        // console.log(`toggelwin ${isLine ? 'lines' : 'scatters'} to process.`);
        // console.log(winObjects);

        const currentObjects: WinObject[] = [];
        let winAmt = 0;

        winObjects.forEach((winObject) => {
            if (winObject.symbolId === winSymbolIds[currentIndex]) {
                currentObjects.push(winObject);
                winAmt += winObject.winAmount;
            }
        })


        // console.log("processWinObjectsToggel", currentObjects);

        // const winSymbolPosistion = currentObject.winSymbolPosistions;
        // const winAmt = currentObject.winAmount;

        // console.log(winSymbolPosistion);
        // console.log(winAmt);

        // this.lineWinText.text = `${winAmt}`;


        // Reset original position 
        // this.resetWinContainer();

        // Initialize winSymbolArray with zeros
        this.initWinSymbolArray();

        this.setWinSymbolArray(currentObjects);


        // console.log(winSymbolArray);

        const lineId = isLine ? winObjects[currentIndex].lineId : null;
        const winlineNumbers: number[] = [];
        if (lineId) {
            winlineNumbers.push(lineId);
        }

        const currentMult = winObjects[currentIndex].winMultiplier;

        await this.animateWinningLines(winlineNumbers, winAmt, currentMult);

        // await this.animateWinLinesSymbol(winSymbolArray, lineId, winLinesSPine, winAmt, true);

        // Move to the next index and call the function recursively
        await this.processWinObjectsToggel(winObjects, winSymbolIds, currentIndex + 1, isLine);
    }

    private async processAllRepeatedly(currentRespinIndex: number): Promise<void> {

        const winLines: WinObject[] | null = spinData.respins[currentRespinIndex].winLines;

        // Uncomment once the backend is fixed
        // const winScatters: WinObject[] | null = spinData.respins[currentRespinIndex].winScatters;

        // const currentMult: number = spinData.respins[currentRespinIndex].multiplier

        // map(line => line.lineId)

        const allWinSymbolIds = spinData.respins[currentRespinIndex].winLines?.map(line => line.symbolId) || [];   //[1, 2, 2, 3, 4, 4, 5];
        const winSymbolIds = allWinSymbolIds.filter((value, index, self) => self.indexOf(value) === index);


        // while (true) {
        if (winLines?.length ?? 0 > 0) {
            await this.processWinObjectsToggel(winLines, winSymbolIds, 0, true);
        }

        // Uncomment once the backend is fixed
        // if (winScatters?.length ?? 0 > 0) {
        //     await this.processWinObjectsToggel(winScatters, winSymbolIds,  0, currentMult, false);
        // }
        // }
    }


    public async lineToggle(currentRespinIndex: number) {

        // await this.makeNonwinSymbolDark();



        console.log("inside lineToggle");


        // if (this.running == false) { // toggel animation

        // this.resetWinContainer();// reset symbols before line toggle
        // this.lineWinText.text = "";

        // Call the function to process both win lines and win scatters repeatedly

        if (spinData.respins[currentRespinIndex].winAmount > 0) {
            // await new Promise(resolve => setTimeout(resolve, 100));
            this.makeNonwinSymbolDark();

            await this.processAllRepeatedly(currentRespinIndex);

            await this.blastAnimation(currentRespinIndex);

        }
        else {
            await new Promise(resolve => setTimeout(resolve, 100));
        }



        this.resetAllSymbols();

    }

    private makeNonwinSymbolDark() {

        // const animationPromises: Promise<void>[] = [];


        let winSymbolFound = false;
        this.winSymbolArray.forEach((reels) => {
            reels.forEach((symbol) => {
                if (symbol != 0) {
                    winSymbolFound = true;
                }
            });
        });

        if (!winSymbolFound) {
            return;
        }

        // const colorOverlayFilter = new ColorOverlayFilter();
        // colorOverlayFilter.color = "#000000";
        // colorOverlayFilter.alpha = 0.7;

        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        this.winSymbolArray.forEach((reels, reelNum) => {
            reels.forEach((symbol, posNum) => {
                if (symbol === 0) { // non winning symbol which will be de-highlighted 

                    let nonWinSymbol = this.allReelArray[reelNum].symbols[posNum].symbol;
                    // console.log(nonWinSymbol);

                    // nonWinSymbol.filters = colorOverlayFilter;

                    nonWinSymbol.tint = "0x555555";

                }
            });
        });




        // const tween = new Tween(colorOverlayFilter, textTweenGroup)
        //     .to({ alpha: 0.7 }, 100)
        //     .onComplete(() => {
        //         textTweenGroup.remove(tween);
        //     })
        //     .start();

        // if (!isFilterApplied) {
        //     this.resetAllSymbols();
        // }

        // if (animationPromises.length > 0) {
        //     await Promise.all(animationPromises);
        // }
        // else {

        //     this.resetAllSymbols();
        //     Promise.resolve();
        // }
        // Promise.resolve();
    }

    private resetAllSymbols() {
        this.allReelArray.forEach((reelObj) => {
            reelObj.symbols.forEach((symbol) => {
                // symbol.symbol.filters = [];
                symbol.symbol.tint = "0xffffff";
            })
        });
    }

    private async blastAnimation(currentRespinIndex: number): Promise<void> {


        const animationPromises: Promise<void>[] = [];


        spinData.respins[currentRespinIndex].cascadePositions?.forEach((position) => {
            // reels.forEach((symbol, posNum) => {

            const reelNum = position[0];
            const posNum = position[1];

            let spineSymbol = this.allReelArray[reelNum].symbols[posNum].symbol;


            const animationPromise = new Promise<void>((resolve) => {
                spineSymbol.state.setAnimation(0, "blast", false).listener = {
                    // spineSymbol.state.setAnimation(0, "land", false).listener = {
                    complete: () => {
                        spineSymbol.state.clearListeners();
                        resolve();
                    },
                };
            });

            animationPromises.push(animationPromise);

            // // spineSymbol.state.setAnimation(0, "blast", false);
            // spineSymbol.state.setAnimation(0, "land", false);

        })

        try {
            if (animationPromises.length > 0) {

                sound.play('symbol_cascade', { volume: 0.3 });

                await Promise.all(animationPromises);
                // await new Promise(resolve => setTimeout(resolve, 100));

            }
        } catch (error) {
            console.error("Error during blastAnimation:", error);
            throw error;
        }
    }





}